<div class="profile__nav" *ngIf="userInfo">
  <div class="userInfos">
    <div class="userInfos__picture">
      <a routerLink="">
        <img
          *ngIf="userInfo.picture?.path"
          src="{{ imgixPath }}{{ userInfo.picture?.path }}?w=40&h=40&fit=crop&auto=format&fm=pjpg&ch=DPR"
          alt="{{ userInfo.firstname | slice: 0:1 }}"
        />
      </a>
    </div>
    <div class="serInfos__text">
      <p class="userInfos__name">{{ userInfo.firstname }}</p>
      <vc-ref
        class="accountLink accountLink--mainAcess"
        i18n-resource="@@HEADER.LINKS.SEE_MY_PROFILE"
        resource="/members/profile-{{ userInfo.id }}.shtml#wall"
        i18n="@@HEADER.PROFILE.SEE_MY_PROFILE"
        >See my profile</vc-ref
      >
      <vc-auth-button *ngIf="!userInfo" type="login" class="accountLink" i18n="@@HEADER.PROFILE.CONNECT"
        >Sign in</vc-auth-button
      >
    </div>
  </div>
  <div class="profileAccesses__section profileAccesses__accountLinks">
    <div class="accountLink getPaidItem" *ngIf="hyperWallet">
      <div class="getPaidIcon" *ngIf="needGetPaidAction">
        <vc-sprite-icons name="issue-full"></vc-sprite-icons>
      </div>
      <vc-ref resource="/get-paid/" (clicked)="resetBox.emit(true)" i18n="@@GET_PAID.TITLE">
        Get Paid
      </vc-ref>
    </div>
    <vc-ref
      i18n-resource="@@HEADER.LINKS.SEE_MY_SALES"
      resource="/my-account.shtml#produits"
      class="accountLink"
      i18n="@@HEADER.PROFILE.MY_SELLS"
      >My items for sale</vc-ref
    >
    <vc-ref
      i18n-resource="@@HEADER.LINKS.SEE_MY_PURCHASES"
      resource="/my-account.shtml#commandes"
      class="accountLink"
      i18n="@@HEADER.PROFILE.MY_PURCHASES"
      >My orders</vc-ref
    >
    <vc-ref
      i18n-resource="@@HEADER.LINKS.SEE_MY_WISHLIST"
      resource="/members/profile-{{ userInfo.id }}.shtml#wishlist"
      class="accountLink"
      i18n="@@HEADER.PROFILE.MY_WISHLIST"
      >My Wishlist</vc-ref
    >
    <vc-ref
      *ngIf="userWallet | async"
      i18n-resource="@@HEADER.LINKS.SEE_MY_WALLET"
      resource="/my-account.shtml#wallet"
      class="accountLink"
      i18n="@@HEADER.PROFILE.MY_WALLET"
      >My wallet: {{ walletAmount }}</vc-ref
    >
    <vc-ref
      *ngIf="userInfo"
      i18n-resource="@@HEADER.LINKS.SEE_MY_ACCOUNT"
      resource="/my-account.shtml"
      class="accountLink accountLink--mainAcess"
      i18n="@@HEADER.PROFILE.SEE_MY_ACCOUNT"
      >See my account</vc-ref
    >
  </div>
  <div class="profileAccesses__section">
    <vc-ref
      i18n-resource="@@HEADER.LINKS.SEE_MY_HELP"
      resource="https://faq.vestiairecollective.com/hc/en-us"
      [blank]="true"
      class="accountLink"
      i18n="@@HEADER.PROFILE.HELP"
      >Help Center</vc-ref
    >
  </div>
  <div *ngIf="userInfo" class="profileAccesses__section">
    <button class="accountLink" (click)="logout()" i18n="@@HEADER.PROFILE.DISCONNECT">Log out</button>
  </div>
</div>
